import { render, staticRenderFns } from "./Metric.vue?vue&type=template&id=cc8a12c6&scoped=true"
import script from "./Metric.vue?vue&type=script&lang=ts"
export * from "./Metric.vue?vue&type=script&lang=ts"
import style0 from "./Metric.vue?vue&type=style&index=0&id=cc8a12c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc8a12c6",
  null
  
)

export default component.exports